module.exports = require("babel-runtime/core-js/promise");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/promise"
// module id = 3
// module chunks = 0